import React from "react";
import PropTypes from "prop-types";


const Add = ({onClick}) => (
  <div>
    <button
      className="btn btn-pink btn-raised btn-long"
      onClick={onClick}
    >
      ADD
    </button>
  </div>
);


Add.propTypes = {
  onClick: PropTypes.func
};

export default Add;
